import { IMockProps, Mocks, MockServiceType } from '../../Core';
import { ENDPOINT_API_PATH } from '../../Apis/ListPartnerTypeApi';
import { ListPartnerTypeMocksDef } from '../../Mocks';

const mocksSuccess: IMockProps[] = [];

const generateSuccess = (language: string): IMockProps => {
  return {
    configRequest: {
      method: 'GET',
      path: ENDPOINT_API_PATH,
      params: { language },
    },
    configResponse: {
      status: 200,
      data: ListPartnerTypeMocksDef.PARTNER_TYPE_LIST,
    },
  };
};

mocksSuccess.push(generateSuccess('pt_br'), generateSuccess('en_us'));

export const mocksService: MockServiceType[] = mocksSuccess.map((request) => ({
  label: `[Sucesso] - ${JSON.stringify(request.configRequest.params)}`,
  value: request.configRequest.params,
}));

const allMocks: IMockProps[] = mocksSuccess;

Mocks.getInstance().addAll(allMocks);
